<script setup lang="ts">
import {computed} from 'vue';

type Gap = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';
interface Props {
    vcenter?: boolean;
    hcenter?: boolean;
    hright?: boolean;
    gap?: Gap;
}

const props = withDefaults(defineProps<Props>(), {
    vcenter: false,
    hcenter: false,
    hright: false,
    gap: '1',
});

const cssClass = computed(() => {
    const classes = [gapClass.value];

    if (props.vcenter) {
        classes.push('is-vcentered');
    }

    if (props.hcenter) {
        classes.push('is-centered');
    }

    if (props.hright) {
        classes.push('stf-flex-right');
    }

    return classes.join(' ');
})

const gapClass = computed(() => {
    return `is-${props.gap}`;
})
</script>

<template>
    <div class="columns is-mobile is-multiline" :class="cssClass">
        <slot />
    </div>
</template>
